var map = {
	"./1.jpg": 199,
	"./10.jpg": 639,
	"./11.jpg": 930,
	"./12.jpg": 157,
	"./2.jpg": 584,
	"./3.jpg": 717,
	"./4.jpg": 958,
	"./5.jpg": 419,
	"./6.jpg": 260,
	"./7.jpg": 305,
	"./8.jpg": 842,
	"./9.jpg": 679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 559;